module.exports = __webpack_public_path__ + "img/whatIsUrbanMining@2x.b957f19.jpg";